import React, { useEffect } from "react";

import { io, Socket } from "socket.io-client";
import { Grid } from "@material-ui/core";

import { Wrapper } from "./styles";
import { paletas } from "../../../../styles/theme";
import { useApp } from "../../../../contexts";
import { InicializarBatalha } from "../../../../servicos";
import { Botao, Divisor, Loading } from "../../../../componentes";

type Props = {
  fecharModo: () => void;
};

interface IBatalhaRegistroResponse {
  time: string;
  socket_id_0: string;
  name_0: string;
  email_0: string;
  socket_id_1: string;
  name_1: string;
  email_1: string;
}

export default function Batalha({ fecharModo }: Props) {
  const { usuario, setUsuarioCorrente } = useApp();
  const [habilitarBusca, setHabilitarBusca] = React.useState(false);
  let updateUsuario = usuario;
  const [socket, setSocket] = React.useState<Socket>();
  const [registry, setRegistry] = React.useState<IBatalhaRegistroResponse>();

  const iniciarBatalha = () => {
    if (usuario) {
      updateUsuario.system.in_combat = true;
      setUsuarioCorrente(updateUsuario);
      setHabilitarBusca(true);

      if (updateUsuario.system.in_combat) procuraBatalha();
    }
  };

  const procuraBatalha = React.useCallback(async () => {
    setSocket(
      io("http://localhost:8080", {
        transports: ["websocket", "polling", "flashsocket"],
      })
    );
  }, []);

  useEffect(() => {
    if (socket) {
      socket.on("connect", () => {
        console.log("connect", socket.id);
      });

      socket.emit("rooms", {
        email: usuario.email,
        name: usuario.name,
        league: usuario.player_statistics.league,
      });

      socket.on("room", (data) => {
        if (data) {
          inicializarBatalha(socket.id);
        }
      });
    }
  }, [socket, usuario]);

  const inicializarBatalha = async (socketId: string) => {
    try {
      const response = await InicializarBatalha(socketId);
      setRegistry(response?.data?.registry);
    } catch (err) {}
  };

  const finalizarBatalha = () => {
    updateUsuario.system.in_combat = false;
    setUsuarioCorrente(updateUsuario);
    setHabilitarBusca(false);
    setRegistry(undefined);

    socket && socket.disconnect();
    console.log("disconnect", socket);
  };

  const TelaInicialBatalha = () => {
    return (
      <>
        <div className="content">
          <Grid item xs={12} className="headerInterno">
            <h3>
              Batalha
              <Divisor color={paletas.DarkOrange} />
            </h3>
            <div>
              <p>
                Consegue resolver algoritmos sob pressão? Desafie outros devs
                nessa modalidade! Vence quem resolver o algoritmo em menor
                tempo.
              </p>
            </div>
          </Grid>
          <Grid item xs={12} sm={6} className="botaoIniciar">
            <Botao
              type="button"
              value="BATALHAR"
              size="22px"
              color={paletas.Grafite75}
              background={paletas.DarkOrange}
              border={paletas.DarkOrange}
              disabled={false}
              onClick={() => iniciarBatalha()}
            />
          </Grid>
        </div>
        <Grid container justify="flex-end">
          <Grid item xs={5} sm={2}>
            <Botao
              type="button"
              value="VOLTAR"
              background={paletas.RedTheme}
              border={paletas.RedTheme}
              color={paletas.White}
              size="16px"
              disabled={false}
              onClick={() => fecharModo()}
            />
          </Grid>
        </Grid>
      </>
    );
  };

  return (
    <Wrapper>
      {habilitarBusca ? (
        <>
          <Grid
            container
            item
            alignContent="center"
            alignItems="center"
            justify="center"
            className="content"
          >
            <Loading loading={!registry} cor={paletas.DarkOrange}>
              <p>
                {registry?.name_0} vs {registry?.name_1}{" "}
              </p>
            </Loading>
          </Grid>
          <Grid container justify="flex-end">
            <Grid item xs={5} sm={2}>
              <Botao
                type="button"
                value="DESISTIR"
                background={paletas.RedTheme}
                border={paletas.RedTheme}
                color={paletas.White}
                size="16px"
                disabled={false}
                onClick={() => finalizarBatalha()}
              />
            </Grid>
          </Grid>
        </>
      ) : (
        <TelaInicialBatalha />
      )}
    </Wrapper>
  );
}
